export const ErrorState = () => <p>Only PDF and DOCX files can be uploaded</p>;

export default ErrorState;
